import { useCallback, useState } from 'react';
import { useImagePaste } from './useImagePaste';

export const useImageInput = (
  active: boolean,
  onImage: (file: File) => void,
) => {
  const [isDragging, setIsDragging] = useState(false);
  useImagePaste(active, onImage);

  const onFileInputChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const file = event.target.files?.[0];
      if (file) onImage(file);
      event.target.value = '';
    },
    [onImage],
  );
  const onDragOver = useCallback((event: React.DragEvent) => {
    event.preventDefault();
    event.stopPropagation();
    setIsDragging(true);
  }, []);
  const onDragLeave = useCallback((event: React.DragEvent) => {
    event.preventDefault();
    event.stopPropagation();
    setIsDragging(false);
  }, []);
  const onDrop = useCallback(
    (event: React.DragEvent) => {
      event.preventDefault();
      event.stopPropagation();
      setIsDragging(false);
      const file = Array.from(event.dataTransfer.files).find((candidate) =>
        candidate.type.startsWith('image/'),
      );
      if (file) onImage(file);
    },
    [onImage],
  );
  return { isDragging, onFileInputChange, onDragOver, onDragLeave, onDrop };
};
